import type { DSLValueLegacy, DerivedEventLegacy } from '@verantos-dev/types-cohorts';

import { transformDerivedEventToDsl } from './transformDerivedEventToDsl';

/**
 *  This function takes in an array of subject variables and returns an array of DSL queries for the cohort definition.
 *
 * @param derivedEvents - The subject variables to transform to DSL queries
 * @returns {DSLValueLegacy[]} - The cohort definition DSL queries
 */
export const transformDerivedEventsToDsl = (
  derivedEvents: DerivedEventLegacy[]
): DSLValueLegacy[] => {
  return derivedEvents?.map((derivedEvent) => transformDerivedEventToDsl(derivedEvent));
};
